export default __webpack_public_path__ + "static/media/services9.ca235abd.jpg";